"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFilterFromJaqlInternal = exports.createFilterFromCustomFilterJaql = exports.createFilterFromPeriodFilterJaql = exports.createFilterFromNumericRangeJaql = exports.createFilterFromDateRangeFilterJaql = exports.createFilterFromSpecificItemsFilterJaql = exports.createFilterIncludeAll = exports.createGenericFilter = void 0;
const types_js_1 = require("./types.js");
const filterFactory = __importStar(require("../factory.js"));
const condition_filter_util_js_1 = require("./condition-filter-util.js");
const filter_types_util_js_1 = require("./filter-types-util.js");
const filter_code_util_js_1 = require("./filter-code-util.js");
const attribute_measure_util_js_1 = require("./attribute-measure-util.js");
const translatable_error_js_1 = require("../../../translation/translatable-error.js");
const filter_config_utils_js_1 = require("../filter-config-utils.js");
/**
 * Creates a generic filter (aka pass-through JAQL filter) if the JAQL cannot be translated to a specific filter type.
 *
 * @param jaql - The JAQL object.
 * @param guid - Optional GUID for the filter
 * @returns A generic Filter object.
 */
const createGenericFilter = (jaql, guid) => {
    return {
        config: Object.assign(Object.assign({}, (0, filter_config_utils_js_1.getDefaultBaseFilterConfig)()), { guid, originalFilterJaql: jaql }),
        jaql: (nested) => {
            if (nested) {
                return jaql;
            }
            return {
                jaql,
                panel: 'scope',
            };
        },
        attribute: {
            id: jaql.dim,
        },
        type: 'filter',
        serializable() {
            return Object.assign(Object.assign({}, this), { jaql: this.jaql() });
        },
        toJSON() {
            return this.serializable();
        },
    };
};
exports.createGenericFilter = createGenericFilter;
/**
 * Creates a filter that includes all members of the attribute.
 *
 * @param attribute - The attribute.
 * @param guid - GUID for the filter
 * @returns The created Filter object.
 */
const createFilterIncludeAll = (attribute, guid) => {
    // including all members is equivalent to excluding none
    // so we can simply create a filter with no members and excludeMembers set to true
    const config = {
        guid,
        excludeMembers: true,
    };
    return (0, filter_code_util_js_1.withComposeCode)(filterFactory.members, 'members')(attribute, [], config);
};
exports.createFilterIncludeAll = createFilterIncludeAll;
/**
 * Creates a filter from a specific items filter JAQL object.
 *
 * @param attribute - attribute
 * @param specificItemsFilterJaql - Specific Items Filter Jaql
 * @param guid - GUID for the filter
 * @returns Filter object
 */
const createFilterFromSpecificItemsFilterJaql = (attribute, specificItemsFilterJaql, guid, multiSelection) => {
    const deactivatedMembers = getDeactivatedMembersFromFilterJaql(specificItemsFilterJaql);
    const activeMembers = getActiveMembersFromFilterJaql(specificItemsFilterJaql, deactivatedMembers);
    const config = (0, filter_config_utils_js_1.simplifyFilterConfig)({
        guid,
        excludeMembers: false,
        enableMultiSelection: multiSelection !== null && multiSelection !== void 0 ? multiSelection : true,
        deactivatedMembers,
    });
    return (0, filter_code_util_js_1.withComposeCode)(filterFactory.members, 'members')(attribute, activeMembers, config);
};
exports.createFilterFromSpecificItemsFilterJaql = createFilterFromSpecificItemsFilterJaql;
function getDeactivatedMembersFromFilterJaql(filterJaql) {
    var _a, _b, _c, _d;
    return ((_a = filterJaql.filter) === null || _a === void 0 ? void 0 : _a.turnedOff) ? (_d = (_c = (_b = filterJaql.filter) === null || _b === void 0 ? void 0 : _b.exclude) === null || _c === void 0 ? void 0 : _c.members) !== null && _d !== void 0 ? _d : [] : [];
}
function getActiveMembersFromFilterJaql(filterJaql, deactivatedMembers) {
    const allMembers = filterJaql.members;
    return deactivatedMembers
        ? allMembers.filter((member) => !deactivatedMembers.includes(member))
        : allMembers;
}
/**
 * Creates a filter from a date range filter JAQL object.
 *
 * @param attribute - attribute
 * @param rangeFilterJaql - Range Filter Jaql
 * @param guid - GUID for the filter
 * @returns Filter object
 */
const createFilterFromDateRangeFilterJaql = (attribute, rangeFilterJaql, guid) => {
    return (0, filter_code_util_js_1.withComposeCode)(filterFactory.dateRange, 'dateRange')(attribute, rangeFilterJaql.from, rangeFilterJaql.to, { guid });
};
exports.createFilterFromDateRangeFilterJaql = createFilterFromDateRangeFilterJaql;
/**
 * Creates a filter from a numeric range filter JAQL object.
 *
 * @param attribute - attribute
 * @param rangeFilterJaql - Range Filter Jaql
 * @param guid - GUID for the filter
 * @returns Filter object
 */
const createFilterFromNumericRangeJaql = (attribute, rangeFilterJaql, guid) => {
    return (0, filter_code_util_js_1.withComposeCode)(filterFactory.between, 'between')(attribute, rangeFilterJaql.from, rangeFilterJaql.to, { guid });
};
exports.createFilterFromNumericRangeJaql = createFilterFromNumericRangeJaql;
/**
 * Creates a filter from a period filter JAQL object.
 *
 * @param attribute - attribute
 * @param periodFilterJaql - Period Filter Jaql
 * @param guid - GUID for the filter
 * @returns Filter object
 */
const createFilterFromPeriodFilterJaql = (attribute, periodFilterJaql, guid) => {
    if (periodFilterJaql.last) {
        return (0, filter_code_util_js_1.withComposeCode)(filterFactory.dateRelativeTo, 'dateRelativeTo')(attribute, periodFilterJaql.last.offset, periodFilterJaql.last.count, periodFilterJaql.last.anchor, { guid });
    }
    else {
        return (0, filter_code_util_js_1.withComposeCode)(filterFactory.dateRelativeFrom, 'dateRelativeFrom')(attribute, periodFilterJaql.next.offset, periodFilterJaql.next.count, periodFilterJaql.next.anchor, { guid });
    }
};
exports.createFilterFromPeriodFilterJaql = createFilterFromPeriodFilterJaql;
/**
 * Creates a filter from a custom filter JAQL object.
 *
 * @param attribute - attribute
 * @param customFilterJaql - Custom Filter Jaql
 * @param guid - GUID for the filter
 * @returns Filter object
 */
const createFilterFromCustomFilterJaql = (attribute, customFilterJaql, guid) => {
    return (0, filter_code_util_js_1.withComposeCode)(filterFactory.customFilter, 'customFilter')(attribute, customFilterJaql, {
        guid,
    });
};
exports.createFilterFromCustomFilterJaql = createFilterFromCustomFilterJaql;
/**
 * Creates a filter from a filter JAQL object.
 *
 * @param jaql - The filter JAQL object.
 * @param guid - GUID for the filter
 * @returns Filter object.
 */
const createFilterFromJaqlInternal = (jaql, guid) => {
    try {
        if ('formula' in jaql) {
            // generic pass-through JAQL filter will be used instead
            throw new translatable_error_js_1.TranslatableError('errors.filter.formulaFiltersNotSupported', {
                filter: JSON.stringify(jaql),
            });
        }
        const filterJaqlWrapperWithType = (0, filter_types_util_js_1.extractFilterTypeFromFilterJaql)(jaql, jaql.datatype);
        const { filter: filterJaqlWithType } = filterJaqlWrapperWithType;
        const { filterType } = filterJaqlWithType;
        const attribute = (0, attribute_measure_util_js_1.createAttributeFromFilterJaql)(jaql);
        const measure = (0, attribute_measure_util_js_1.createMeasureFromFilterJaql)(jaql);
        switch (filterType) {
            case types_js_1.FILTER_TYPES.INCLUDE_ALL:
                return (0, exports.createFilterIncludeAll)(attribute, guid);
            case types_js_1.FILTER_TYPES.SPECIFIC_ITEMS:
                return (0, exports.createFilterFromSpecificItemsFilterJaql)(attribute, filterJaqlWithType, guid, filterJaqlWithType.multiSelection);
            case types_js_1.FILTER_TYPES.CONDITION:
                if (measure) {
                    return (0, condition_filter_util_js_1.createMeasureFilterFromConditionFilterJaql)(measure, filterJaqlWithType, guid);
                }
                else {
                    return (0, condition_filter_util_js_1.createAttributeFilterFromConditionFilterJaql)(attribute, filterJaqlWithType, guid);
                }
            case types_js_1.FILTER_TYPES.DATE_RANGE:
                return (0, exports.createFilterFromDateRangeFilterJaql)(attribute, filterJaqlWithType, guid);
            case types_js_1.FILTER_TYPES.PERIOD:
                return (0, exports.createFilterFromPeriodFilterJaql)(attribute, filterJaqlWithType, guid);
            case types_js_1.FILTER_TYPES.NUMERIC_RANGE:
                return (0, exports.createFilterFromNumericRangeJaql)(attribute, filterJaqlWithType, guid);
            case types_js_1.FILTER_TYPES.ADVANCED:
                return (0, exports.createFilterFromCustomFilterJaql)(attribute, filterJaqlWithType, guid);
            case types_js_1.FILTER_TYPES.INVALID:
                return (0, exports.createGenericFilter)(jaql, guid);
        }
    }
    catch (e) {
        // if a filter type is untranslatable, fall back to the generic pass-through JAQL filter
        console.debug('Fall back to generic pass-through JAQL filter due to filter translation error:', e);
    }
    return (0, exports.createGenericFilter)(jaql, guid);
};
exports.createFilterFromJaqlInternal = createFilterFromJaqlInternal;
